@import (reference) '~ss-ui-client/src/constants/spacing.module.less';

.container {
  padding: @space-16;
  border-radius: 8px;
  background: var(--light--background-color--1);
  border: solid 1px var(--default--border-color--12);
}

.header {
  line-height: 1.875rem;
}

.items {
  padding: @space-0 @space-0 @space-0 @space-16;
}

.divider {
  border-color: var(--default--border-color--13);
}

.totalAmountLabelWrapper {
  justify-content: space-between;
}

.totalAmountLabel label {
  font-size: 16px;
}

.totalAmount {
  font-size: 16px;
  font-weight: 500;

  &.refundTotal {
    color: var(--red-700);
  }
}

.process-button {
  height: 40px;
}

.disclaimer {
  color: var(--grey-600);
}
